import { writable } from "svelte/store";

export const accountInfo = writable(null);
export const jwt_token = writable(null);
export const refreshToken = writable(null);
export const fcm_token = writable("");

export const refreshTrigger = writable(0);

// const asState = () => ({
//     asList: [],
//     currentList: [],
// });

// export const asStore = writable(asState());

// export function resetAsStore() {
//     asStore.set(asState());
// }
